module.exports = __webpack_public_path__ + "media/images/version_merge/aaa-3c43fcd141dbe6b4b85de26d3c75920e.png";